import { type IconProp } from '@atlaskit/button/new';
import type { UIEventPayload } from '@atlassiansox/analytics-web-client';
import type { ReactNode } from 'react';

export type UserInfoResponse = {
	account_id: string;
	email: string;
	name: string;
	picture: string;
	account_status: string;
	characteristics: {
		not_mentionable: false;
	};
	last_updated: string;
	nickname: string;
	zoneinfo: string;
	locale: string;
	extended_profile: {
		job_title: string;
		location: string;
		team_type: string;
	};
	account_type: string;
	email_verified: boolean;
};

export enum envType {
	LOCAL = 'local',
	DEV = 'dev',
	STAGING = 'staging',
	PROD = 'prod',
}

export type Action = {
	label: string;
	icon?: IconProp;
	action?: () => void;
	children?: ReactNode;
	href?: { link: string; target?: string };
	analyticEvent?: UIEventPayload;
	testId?: string;
};
